import { Badge, Tooltip } from 'antd'
import { WifiOutlined, DisconnectOutlined } from '@ant-design/icons'

interface Props {
  status: string
  lastSeen?: string
  showText?: boolean
}

export function HeartbeatBadge({ status, lastSeen, showText = true }: Props) {
  const isOnline = status === 'online'
  const lastSeenText = lastSeen
    ? `最后活跃：${new Date(lastSeen).toLocaleString('zh-CN')}`
    : '从未连接'

  return (
    <Tooltip title={lastSeenText}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <Badge
          status={isOnline ? 'success' : 'default'}
          text={
            showText ? (
              <span style={{ color: isOnline ? '#52c41a' : '#aaa', fontSize: 13 }}>
                {isOnline ? '在线' : '离线'}
              </span>
            ) : null
          }
        />
        {isOnline
          ? <WifiOutlined style={{ color: '#52c41a', fontSize: 12 }} />
          : <DisconnectOutlined style={{ color: '#aaa', fontSize: 12 }} />}
      </span>
    </Tooltip>
  )
}
